import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { NgbDateStruct, NgbInputDatepicker } from "@ng-bootstrap/ng-bootstrap";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { shortKey } from "apps-module/app/shared-library/utils/common.utils";
import { NumericUtils } from "apps-module/app/shared-library/utils/numeric.utils";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { takeUntil } from "rxjs";

@Component({
    selector: "[pcg-ng-date-picker]",
    templateUrl: "./date-picker.component.html",
    host: {
        "class": "pcg-form-group"
    }
})
export class DatePickerComponent extends DestroyableMixin(EmptyInstance) implements OnInit  {
    public control = new FormControl<NgbDateStruct>(null);

    @Input()
    public label: string = null;

    @Output()
    public onSubmit = new EventEmitter();

    public originalControl: FormControl<string> = null;
    @Input("control")
    public set controlSetter(originalControl: FormControl<string>) {
        this.originalControl = originalControl;
        const dateValues = originalControl.value.split("-");
        this.control.setValue({
            year: NumericUtils.parse(dateValues[0], null),
            month: NumericUtils.parse(dateValues[1], null),
            day: NumericUtils.parse(dateValues[2], null)
        } as NgbDateStruct);
    }

    public id: string = null;

    public ngOnInit(): void {
        this.id = shortKey();
        this.control.valueChanges.pipe(
            takeUntil(this.onDestroy)
        ).subscribe((value: NgbDateStruct) => {
            if (value) {
                this.originalControl.setValue(`${value.year}-${value.month}-${value.day}`);
            }
            else{
                this.originalControl.setValue("");
            }
            this.onSubmit.emit();
        });
    }

    public clear(picker: NgbInputDatepicker): void {
        this.control.setValue(null);
        picker.close();
    }
}
